import { ResourceManager } from "@/components/ResourceManager";
import { GalleryHorizontalEnd } from "lucide-react";

const fields = [
  { name: "title", label: "Title", type: "text" },
  { name: "subtitle", label: "Subtitle", type: "text", table: false },
  { name: "image_path", label: "Image", type: "image" },
  { name: "cta_text", label: "Button Text", type: "text", table: false },
  { name: "cta_link", label: "Button Link", type: "text", table: false },
  { name: "order", label: "Order", type: "number" },
];

export default function BannersAdmin() {
  return <ResourceManager title="Home Banners" eyebrow="Content" endpoint="banners" fields={fields} hasPublish icon={GalleryHorizontalEnd} />;
}
